import { useApiGet } from '../../../../../shared/api/utils/reactQueryProvider';
import { getRiderRequiredServices } from '../../../../api/services/Riders';
import { RiderRequiredServicesResponse } from '../../../../types/rider';

interface IUseRiderRequiredServicesQuery {
  rideSlug: string;
  riderSlug: string;
}

export const useRiderRequiredServicesQuery = ({ rideSlug, riderSlug }: IUseRiderRequiredServicesQuery) => {
  return useApiGet<{ data: RiderRequiredServicesResponse }>(
    ['riderRequiredServices', riderSlug],
    () => getRiderRequiredServices(rideSlug, riderSlug),
    {
      enabled: true,
    }
  );
};
